function initialize() {
  // your bundle keywords and images
  const bundleDefs = [
    { keyword: 'Baking Bundle',   src: 'https://i.postimg.cc/bJBL5njL/Baking-Bundle.png'   },
    { keyword: 'Immunity Bundle', src: 'https://i.postimg.cc/zvNw6FcC/Immunity-Bundle.png' },
    { keyword: 'Everyday + Boost', src: 'https://i.postimg.cc/VLYBF4M1/Everyday-Boost.png' },
    { keyword: 'Ultimate Wellness Bundle', src: 'https://i.postimg.cc/9XpcDtjs/Ultimate-Wellness-Bundle.png' },
    { keyword: 'Beauty Bundle', src: 'https://i.postimg.cc/c1T8dWgy/Beauty-Bundle.png' },
  ];

  document.querySelectorAll('.rebuy-cart__flyout-item').forEach(item => {
    var titleEl = item.querySelector('.rebuy-cart__flyout-item-product-title');
    
    // Skip if the title is "Bamboo Beauty Bundle"
    if (titleEl && titleEl.textContent === 'Bamboo Beauty Bundle') {
      return; // Skip this item
    }

    if (!titleEl) return; // If no title, skip it

    const titleText = titleEl.textContent.trim();

    // Try each definition
    bundleDefs.forEach(def => {
      if (titleText.includes(def.keyword)) {
        // 1) Swap in the right image
        const img = item.querySelector('.rebuy-cart__flyout-item-media img');
        if (img) {
          img.src = def.src;
          img.alt = def.keyword;
        }

        // 2) Fully disable all links
        item.querySelectorAll('a, button').forEach(el => {
          el.removeAttribute('href');
        });
      }
    });
  });
}

(function() {
  const SELECTOR = '.rebuy-cart__flyout-item';
  function ready(fn) {
    if (document.querySelector(SELECTOR)) fn();
    else setTimeout(() => ready(fn), 100);
  }
  ready(initialize);

  new MutationObserver(muts => {
    if (muts.some(m => m.addedNodes.length)) setTimeout(initialize, 100);
  }).observe(document.body, { childList: true, subtree: true });
})();






// Function to disable the link and quantity input if the product name contains any of the specified bundles
function disableBundleLinks() {
  const cartItems = document.querySelectorAll('.cart-item__details_cart_page');

  // List of specific product names to match (case-insensitive)
  const bundleNames = [
    "Baking Bundle",
    "Immunity Bundle",
    "Everyday + Boost",
    "Ultimate Wellness Bundle",
    "Beauty Bundle"
  ];

  cartItems.forEach(item => {
    const productNameElement = item.querySelector('.cart-item__name');
    
    // Check if the product name contains any of the specified bundle names (case insensitive)
    if (productNameElement && bundleNames.some(name => productNameElement.textContent.toLowerCase().includes(name.toLowerCase()))) {
      // Find the <a> tag within the product details
      const productLink = item.querySelector('a.cart-item__name');

      // If the link exists, remove the href and prevent default behavior on click
      if (productLink) {
        productLink.removeAttribute('href');  // Remove the href attribute
        productLink.addEventListener('click', function(event) {
          event.preventDefault();  // Prevent the link from being clicked
        });
      }

      // Block the quantity input field as well (disable it)
      const quantityInput = item.querySelector('.quantity__input');
      if (quantityInput) {
        quantityInput.setAttribute('disabled', 'true');  // Disable the input
      }
    }
  });
}

// Check if the current page path is '/cart'
if (window.location.pathname === '/cart') {
  // Call the function initially to disable links and inputs
  disableBundleLinks();

  // Create a MutationObserver to watch for changes in the body (for cart updates)
  const observer = new MutationObserver(() => {
    disableBundleLinks();  // Reapply the logic whenever the body content changes
  });

  // Start observing the <body> element for changes in child nodes
  observer.observe(document.body, { childList: true, subtree: true });
}

